export default "__VITE_ASSET__BDLXfZV3__"